import { render, staticRenderFns } from "./IcoTeam.vue?vue&type=template&id=62e17f30&scoped=true"
import script from "./IcoTeam.vue?vue&type=script&lang=js"
export * from "./IcoTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e17f30",
  null
  
)

export default component.exports